import React, {ReactNode, useEffect, useState} from "react";
import {Tooltip as ReactTooltip} from "react-tooltip";
import MarkdownText from "../markdown/markdown-text/MarkdownText";
import {css} from "/src/utils/utils";

import * as styles from "./tooltip.module.scss";

interface Props {
  content?: string; // String content
  contentHtmlSanitized?: string; // Pre-sanitized HTML content
  id: string;
  outerClasses?: string;
  popupClasses?: string;
  position?: "top" | "bottom" | "left" | "right";
  triggerElem: ReactNode | string;
  triggerLabel?: string;
  wrapInAButton?: boolean;
}

export default function Tooltip(props: Props) {
  const {
    content,
    contentHtmlSanitized,
    id,
    outerClasses = "",
    popupClasses = "",
    position = "top",
    triggerElem,
    triggerLabel = "tooltip",
    wrapInAButton = false,
  } = props;

  const [mounted, setMounted] = useState(false);
  // Show tooltip if we have either sanitized content or raw content
  const shouldShow =
    triggerElem != null &&
    (contentHtmlSanitized != null || content != null) &&
    id != null;

  useEffect(() => {
    if (!mounted) {
      setMounted(true);
    }
  }, [mounted]);

  return shouldShow ? (
    <div className={css(styles.tooltip, outerClasses)}>
      {wrapInAButton ? (
        <button
          aria-label={`${triggerLabel}`}
          aria-describedby={`#${id}`}
          className={styles.tooltip__triggerButton}
          data-tooltip-id={id}
          type="button"
        >
          {triggerElem}
        </button>
      ) : (
        <div className={styles.tooltip__trigger} data-tooltip-id={id}>
          {triggerElem}
        </div>
      )}

      {mounted && (
        <ReactTooltip
          className={css(styles.tooltip__content, popupClasses)}
          clickable
          delayShow={300}
          id={id}
          place={position}
        >
          {contentHtmlSanitized ? (
            <MarkdownText htmlContent={contentHtmlSanitized} />
          ) : (
            <p>{content}</p>
          )}
        </ReactTooltip>
      )}
    </div>
  ) : null;
}
